import { useLoaderData } from "react-router";
import FieldEdit from "../components/FieldEdit.jsx";
import { useAuthStore } from "../store/authStore.js";

function FieldDraftEditPage() {
  const { draft, original } = useLoaderData();
  const isAdmin = useAuthStore((state) => state.isAdmin);
  return <FieldEdit method="put" field={draft} originalField={original} isDraft={true} readOnly={!isAdmin()} />;
}

export default FieldDraftEditPage;
